import { render } from "./SchemaSelection.vue?vue&type=template&id=ef294b6a&scoped=true&ts=true"
import script from "./SchemaSelection.vue?vue&type=script&lang=ts"
export * from "./SchemaSelection.vue?vue&type=script&lang=ts"

import "./SchemaSelection.vue?vue&type=style&index=0&id=ef294b6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef294b6a"]])

export default __exports__